import { APIClient } from 'utils/api/api'

export const KETCH_CDN_API = new APIClient((window as any)?.figureheadConfig?.REACT_APP_KETCH_CDN_API_URL)
